import script from "./PhotographerEventSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotographerEventSingle.vue?vue&type=script&setup=true&lang=js"

import "./PhotographerEventSingle.vue?vue&type=style&index=0&id=c13e0944&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c13e0944"]])

export default __exports__